import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "ipiranga",
        nomePrefeitura: "Prefeitura Municipal de Ipiranga",
        logo: "ipiranga/logos/brasao.png",
        brasao: "ipiranga/logos/logo.png",
        municipio: "| IPIRANGA - PR",
    },
    webgeo: {
        allowMapDragAtAnyZoom: true,
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape: "",
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: false,
            consultaPrevia: true,
            iptu: false,
            laws: false,
            cemiterio: true,
        },
        map: {
            center: [-50.5839503, -25.0253338],
            zoom: 18,
        },
        cemiterio: {
            municipio: "Ipiranga",
            center: [-5630445.661330851, -2877733.71873303],
            nome: "Cemitério Municipal de Ipiranga",
        },
    },
    api: {
        url: "http://localhost:3330",
    },
    geoserver: {
        url: process.env.REACT_APP_MIGRATION
            ? "https://geoserver-migration.semv.com.br/geoserver"
            : "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
